import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/NavBar.scss";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
const NavBar: React.FC = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLUListElement>(null);
  const toggleRef = useRef<HTMLButtonElement>(null);

  const handleToggle = () => setMenuOpen((open) => !open);
  const handleLinkClick = () => setMenuOpen(false);

  // Close menu when clicking outside
  useEffect(() => {
    if (!menuOpen) return;
    const handleClick = (e: MouseEvent) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target as Node) &&
        toggleRef.current &&
        !toggleRef.current.contains(e.target as Node)
      ) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [menuOpen]);

  useEffect(() => {
    if (!menuOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [menuOpen]);

  return (
    <nav className="navbar" aria-label="Main">
      <div className="navbar-logo">
        <Link
          to="/"
          className="navbar-title"
          style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
        >
          <img
            src="/smallLogo.png"
            alt="Rate My Cribs"
            width={48}
            height={48}
            style={{
              height: "3rem",
              width: "3rem",
              objectFit: "contain",
              marginRight: "0.3rem",
            }}
            decoding="async"
          />
          <span aria-hidden="true">Rate My Cribs</span>
        </Link>
      </div>
      <button
        className={`navbar-toggle${menuOpen ? " open" : ""}`}
        onClick={handleToggle}
        aria-label={menuOpen ? "Close menu" : "Open menu"}
        aria-expanded={menuOpen}
        aria-controls="navbar-links"
        ref={toggleRef}
      >
        {menuOpen ? (
          <ExpandLessIcon sx={{ color: "primary.main" }} aria-hidden />
        ) : (
          <MenuIcon sx={{ color: "primary.main" }} aria-hidden />
        )}
      </button>
      <ul
        id="navbar-links"
        className={`navbar-links${menuOpen ? " open" : ""}`}
        ref={menuRef}
      >
        <li>
          <Link
            to="/"
            className={location.pathname === "/" ? "active" : ""}
            onClick={handleLinkClick}
          >
            Home
          </Link>
        </li>
        <li>
          <Link
            to="/submit"
            className={location.pathname === "/submit" ? "active" : ""}
            onClick={handleLinkClick}
          >
            Submit Review
          </Link>
        </li>
        <li>
          <Link
            to="/reviews"
            className={location.pathname === "/reviews" ? "active" : ""}
            onClick={handleLinkClick}
          >
            View Reviews
          </Link>
        </li>
        <li>
          <Link
            to="/map"
            className={location.pathname === "/map" ? "active" : ""}
            onClick={handleLinkClick}
          >
            Map
          </Link>
        </li>
        <li>
          <Link
            to="/about"
            className={location.pathname === "/about" ? "active" : ""}
            onClick={handleLinkClick}
          >
            About
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default NavBar;
